
import { Mapper } from "../../../../../core/base";
import {Tag} from "../../../../../core/domain";
import { TagWebEntity } from "./tag-web-entity";

export class TagsWebRepositoryMapper extends Mapper<TagWebEntity, Tag> {

  mapFrom(param: TagWebEntity): Tag {
    return {
      id: param.id,
      name: param.name,
      isProduct : param.isProduct
    };
  }

  mapTo(param: Tag): TagWebEntity {
    return {
        id: param.id,
        name: param.name,
        isProduct : param.isProduct
    };
  }

}
